/**
 * Appends `callbackurl` (current page) so auth UI can redirect back after login/signup.
 * Works for both external (`usetype=E`) and internal (`usetype=I`) URLs from env.
 */
export function withAuthCallbackUrl(url) {
    const u = url.trim();
    if (!u || typeof window === 'undefined')
        return u;
    const callback = window.location.href;
    try {
        const parsed = u.startsWith('http://') || u.startsWith('https://')
            ? new URL(u)
            : new URL(u, window.location.origin);
        if (u.includes('callbackurl='))
            return u; // Already has callbackurl, no need to append
        parsed.searchParams.set('callbackurl', callback);
        return parsed.toString();
    }
    catch {
        const join = u.includes('?') ? '&' : '?';
        return `${u}${join}callbackurl=${encodeURIComponent(callback)}`;
    }
}
